import { Save } from "lucide-react";

/**
 * Floating save bar pinned to the bottom of the viewport. Used inside Admin
 * tabs so the save action stays reachable while the user scrolls a long form.
 *
 * Mirrors the visual language of `StickyBottom` (dark blur, gold-tint border)
 * but is purpose-built for a single primary action.
 */
export default function FloatingSaveBar({
  onSave,
  saving = false,
  disabled = false,
  label = "Save",
  savingLabel,
  testId,
  bottomOffset = 0,
}) {
  const isDisabled = disabled || saving;
  const text = saving ? (savingLabel || `${label}…`) : label;
  return (
    <div
      className="fixed inset-x-0 z-40 backdrop-blur-xl bg-[#0A0C10]/90 border-t border-white/5 no-print"
      style={{ bottom: bottomOffset }}
      data-testid="admin-floating-save-bar"
    >
      <div className="max-w-2xl mx-auto px-4 pr-28 sm:pr-4 py-3.5">
        <button
          type="button"
          onClick={onSave}
          disabled={isDisabled}
          className="btn-primary w-full flex items-center justify-center gap-2"
          data-testid={testId}
        >
          <Save size={16} /> {text}
        </button>
      </div>
    </div>
  );
}
